import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/authentication/authContext";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
/* import logo from '../img/FACEA19.jpg'; */
import { Link } from "react-router-dom";
import { MenuData } from "./MenuData";

const Navbar = () => {
  const authToken = useContext(AuthContext);
  const { usuarioAutenticado, user, cerrarSesion } = authToken;

  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    usuarioAutenticado();
    // eslint-disable-next-line
  } , [])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="main-navbar sticky-top bg-white">
      <nav className="navbar align-items-stretch navbar-light flex-md-nowrap p-0" style={{boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 5%), inset 0 -1px 0 rgb(0 0 0 / 15%)'}} >        

        <div>
          <Button
            aria-controls="customized-menu"
            aria-haspopup="true"
            variant="contained"
            color="primary"
            onClick={handleClick}
          >
            Menu
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {MenuData.filter(x => x.user === user.profile).map((item, index) => {
              return (
                <MenuItem onClick={handleClose} key={index}>
                  <Link to={item.path} className="nav-link">
                    <i className="material-icons">{item.icon}</i>
                    <span>{item.title}</span>
                  </Link>
                </MenuItem>
              );
            })}
          </Menu>
        </div> 

        {/* <div>
          <img src={logo} className="logo" alt="logo" />
        </div> */}       

        <div className="input-group input-group-seamless ml-3">
          <div className="input-group-prepend">
            <div className="input-group-text">
              <span className="label label-default">
                <h4 className="page-title">
                  Bienvenid@, {user.name + " " + user.last_name}
                </h4>
              </span>
            </div>
          </div>
        </div>

        <ul className="navbar-nav border-left flex-row ">
          <li className="nav-item border-right dropdown notifications">
            <button
              className="nav-link nav-link-icon text-center"
              title="Cerrar sesion"
              onClick={() => cerrarSesion()}
            >
              <div className="nav-link-icon__wrapper">
                <i className="material-icons">exit_to_app</i>
              </div>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
